import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=c92c82d4&scoped=true&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=c92c82d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92c82d4",
  null
  
)

export default component.exports